import { HttpUrlEncodingCodec } from '@angular/common/http';

const httpEncoder = new HttpUrlEncodingCodec();
export const URL_UTILS = {
  encodeUrlQueryParamValue: (queryParamValue: string) => {
    return httpEncoder.encodeValue(queryParamValue);
  },
};
